import { autoMount } from '../../../utils/autoMount';
import { PersonTerms } from '../../../components/pages/personTerms';

autoMount({ PersonTerms });
